import { PRESCRIPTION_CANONICAL } from '../../constants/defaults';

export const getLdJson = data => {
  let structuredData = {
    '@context': 'https://schema.org',
    '@type': 'MedicalWebPage',
    publisher: {
      '@type': 'Organization',
      name: 'SingleCare',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static-singlecare.s3.amazonaws.com/tenant/singlecare/images/main-logo.png'
      }
    },
    headline: data && data.metaTitle,
    description: data && data.metaDescription,
    author: {
      '@type': 'Organization',
      name: 'SingleCare',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.singlecare.com/blog/wp-content/themes/singlecare_blog/images/top-bar-logo-new.png'
      }
    },
    url: `${PRESCRIPTION_CANONICAL}${data.slug}/dosage`,
    datePublished: data && data.publishedAt,
    dateModified: data && data.publishedAt,
    relatedLink: data.relatedDosageGuides.map(
      value => `${PRESCRIPTION_CANONICAL}${value.slug}/dosage`
    ),
    drug: getRelatedLinks(data),
    image: ''
  };
  return JSON.stringify(structuredData);
};
const getRelatedLinks = data => {
  let relatedDrugs = [];
  if (data && data.linkedDrugs) {
    data.linkedDrugs.forEach(function (relatedDrug) {
      let relatedItem = {
        '@type': 'Drug',
        name: relatedDrug.name,
        url: `${PRESCRIPTION_CANONICAL}${relatedDrug.seoName}`,
        nonProprietaryName: relatedDrug.name
      };
      relatedDrugs.push(relatedItem);
    });
  }
  return relatedDrugs;
};
